module.exports = __webpack_public_path__ + "static/media/straw.5107a357.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/straw.jpeg
// module id = 299
// module chunks = 0